module.exports = __webpack_public_path__ + "81fbff8f855a2d2a86cd8b8e3008b8.svg";